// useHelpForm.ts
import { useState, useCallback } from 'react';
import { HelpRequestPayload } from '../../api/User.client';

export function useHelpForm(
  initialFormData: any,
  validateEmail: (email: string) => string | null
) {
  const [formData, setFormData] = useState(initialFormData);
  const [emailError, setEmailError] = useState<string | null>(null);

  const handleInputChange = useCallback(
    (field: keyof typeof initialFormData) =>
      (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any
      ) => {
        const value = event.target.value;
        setFormData((prev: any) => ({
          ...prev,
          [field]: value,
        }));
        if (field === 'email') setEmailError(validateEmail(value));
      },
    [validateEmail]
  );

  const clearForm = () => {
    setFormData(initialFormData);
    setEmailError(null);
  };

  return {
    formData,
    setFormData,
    emailError,
    setEmailError,
    handleInputChange,
    clearForm,
  };
}
